import React, { Component } from 'react';
import { Input, Dropdown, Icon } from 'semantic-ui-react';
//@ts-ignore
import InputMask from 'react-input-mask';
import PhoneNumber from 'awesome-phonenumber';

import { __ } from '../../lib/I18n';
import countries from '../../lib/countries';

/**
 * @typedef {{
 *  value: string,
 *  country: string
 *  onChange: (phone: string) =>void,
 *  onChangeCountry: (country: string) => void
 *  onConfirm: () => void
 * }} Props
 * @extends {Component<Props>}
 */
export default class PhoneInput extends React.Component {
  /** @param {Props} props */
  constructor(props) {
    super(props);

    this.state = {
      error: null
    };
  }

  /**
   * @returns {boolean}
   */
  validate = () => {
    const { value, country } = this.props;
    const pn = new PhoneNumber(value, country);
    if (!pn.isValid()) {
      this.onError();
      return false;
    }

    return true;
  };

  onConfirm = () => {
    const { onConfirm } = this.props;

    if (this.validate() && onConfirm) onConfirm();
  };

  onError = () => {
    this.setState({ error: 'Não foi possível encontrar sua conta no ClassApp' });
  };

  render() {
    const { error } = this.state;
    const { value, onChange, country, onChangeCountry } = this.props;

    return (
      <div className={`input-component ${error ? 'error' : ''}`} style={{ marginBottom: '2.5rem' }}>
        <h5 style={{ marginBottom: '.5rem', marginLeft: '1rem' }}>{__('Celular')}</h5>
        <InputMask
          mask="(99)99999-9999"
          value={value}
          style={{ marginLeft: '1rem', marginTop: '0.5rem', position: 'relative', flex: 1 }}
          onChange={/** @param {any} e*/(e) => onChange(e.target.value)}
          onKeyPress={/** @param {any} e*/(e) => e.key === 'Enter' && this.onConfirm()}
          placeholder="DDD + Celular"
        >
          {/** @param {any} inputProps */inputProps => (
            <Input
              {...inputProps}
              style={{ width: '23rem' }}
              label={(
                <Dropdown
                  icon="angle down"
                  defaultValue={country}
                  options={countries}
                  style={{ background: '#0069ff', color: 'white', fontWeight: 400 }}
                  onChange={(e) => {
                    const selectedCountry = countries.filter(
                      c => c.text === (/** @type {HTMLElement} */(e.target)).innerText
                    )[0];
                    onChangeCountry(selectedCountry.key);
                  }}
                />
              )}
              labelPosition="left"
              error={error}
            />
          )}
        </InputMask>
        {error && (
          <div className="error-warning">
            <Icon className="circle exclamation" />
            <span>{__(error)}</span>
          </div>
        )}
      </div>
    );
  }
}
